import {
  FETCH_DASHBOARD_ACTIVITY_LIST_FAILURE,
  FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST,
  FETCH_DASHBOARD_ACTIVITY_LIST_SUCCESS,
  FETCH_DASHBOARD_AVG_DETAILS_FAILURE,
  FETCH_DASHBOARD_AVG_DETAILS_REQUEST,
  FETCH_DASHBOARD_AVG_DETAILS_SUCCESS,
  FETCH_DASHBOARD_DATE_RANGE_LIST_FAILURE,
  FETCH_DASHBOARD_DATE_RANGE_LIST_REQUEST,
  FETCH_DASHBOARD_DATE_RANGE_LIST_SUCCESS,
} from "./actionTypes";
import {
  DashboardActivityList,
  DashboardDateRangeActivityList,
  DashboardActivityAvgDetails,
  DashboardPayload,
} from "./types";

export const fetchDashboardActivityListRequest = (
  url: string,
  payload: DashboardPayload
) => ({
  type: FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST,
  url,
  payload,
});

export const fetchDashboardActivityListSuccess = (
  data: DashboardActivityList[] | DashboardDateRangeActivityList[]
) => ({
  type: FETCH_DASHBOARD_ACTIVITY_LIST_SUCCESS,
  payload: data,
});

export const fetchDashboardActivityListFailure = (error: string) => ({
  type: FETCH_DASHBOARD_ACTIVITY_LIST_FAILURE,
  payload: error,
});

export const fetchDashboardDateRangeListRequest = (
  url: string,
  payload: DashboardPayload
) => ({
  type: FETCH_DASHBOARD_DATE_RANGE_LIST_REQUEST,
  url,
  payload,
});

export const fetchDashboardDateRangeListSuccess = (
  data: DashboardDateRangeActivityList[] | DashboardActivityList[]
) => ({
  type: FETCH_DASHBOARD_DATE_RANGE_LIST_SUCCESS,
  payload: data,
});

export const fetchDashboardDateRangeListFailure = (error: string) => ({
  type: FETCH_DASHBOARD_DATE_RANGE_LIST_FAILURE,
  payload: error,
});

export const fetchDashboardAvgDetailsRequest = (
  url: string,
  payload: DashboardPayload
) => {
    return {
        type: FETCH_DASHBOARD_AVG_DETAILS_REQUEST,
        url,
        payload,
      }
};

export const fetchDashboardAvgDetailsSuccess = (
    activityAvgDetails: DashboardActivityAvgDetails
) => ({
  type: FETCH_DASHBOARD_AVG_DETAILS_SUCCESS,
  payload: activityAvgDetails,
});

export const fetchDashboardAvgDetailsFailure = (error: string) => ({
  type: FETCH_DASHBOARD_AVG_DETAILS_FAILURE,
  payload: error,
});
